// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__xKv3Z","singleComponent":"Breadcrumb_singleComponent__Orgwy"};